import React from 'react';

export default function ChevronRightIcon() {
  return <path d="m9 18 6-6-6-6" />;
}
